import { LeftBar } from "../../components";
import Main from "./component.main";
import store from "./script.store";
const ScreenGroups = { LeftBar, Main, store };
export default ScreenGroups;
